import { render, staticRenderFns } from "./SharedLinkRestoreFile.vue?vue&type=template&id=c8938d94&scoped=true&"
import script from "./SharedLinkRestoreFile.vue?vue&type=script&lang=js&"
export * from "./SharedLinkRestoreFile.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkRestoreFile.vue?vue&type=style&index=0&id=c8938d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8938d94",
  null
  
)

export default component.exports